import { Progress } from "antd";
import { useEffect, useState } from "react";

interface AnimatedProgressProps {
  percent: number;
  status: string;
  trailColor?: string;
}

export const AnimatedProgress = ({ percent, trailColor, status }: AnimatedProgressProps) => {
  const [animatedPercent, setAnimatedPercent] = useState(0);

  useEffect(() => {
    const step = percent > animatedPercent ? 1 : -1;
    const interval = setInterval(() => {
      setAnimatedPercent((prev) => {
        const next = prev + step;
        if ((step > 0 && next >= percent) || (step < 0 && next <= percent)) {
          clearInterval(interval);
          return percent;
        }
        return next;
      });
    }, 10);

    return () => clearInterval(interval);
  }, [percent]);

  return (
    <Progress
      percent={Math.round(animatedPercent)}
      showInfo={false}
      className={
        status === "ACTIVE" || status === "INACTIVE" ? "animated-slide-progress" : "progress-grey"
      }
      trailColor={trailColor}
    />
  );
};
